module.exports = __webpack_public_path__ + "static/media/des-expectations-mobile.103481e2.png";